import React, { FC, ReactElement } from 'react';
import { useTranslation } from '@app/core/i18n';

import classNames from 'classnames';

import Wallet from '@ast/magma/components/icon/icons/Wallet';

import styles from './NoItemsNotifier.pcss';

export interface NoItemsNotifierProps {
  title?: string,
  tagline?: string,
  icon?: ReactElement,
  className?: string;
  // eslint-disable-next-line i18next/no-literal-string
  'aria-label'?: string;
  contactInfo?: string;
  // eslint-disable-next-line i18next/no-literal-string
  'data-stable-name'?: string;
}

export const NoItemsNotifier: FC<NoItemsNotifierProps> = ({
  title,
  icon = <Wallet />,
  tagline,
  className,
  // eslint-disable-next-line i18next/no-literal-string
  'aria-label': ariaLabel,
  contactInfo,
  // eslint-disable-next-line i18next/no-literal-string
  'data-stable-name': dataStableName,
}) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className={classNames(className, styles.notifier)}
      aria-label={ariaLabel || tagline || t(
        'no-items-notifier|No item notifier dialog default aria-label',
        'There is no data to display.',
      )}
      data-stable-name={dataStableName || 'NoItemsNotifier'}
    >
      <div className={styles.background} />
      <span className={styles.icon} data-stable-name="NoItemsNotifierIcon">
        {icon}
      </span>
      { title && (
        <h3 aria-hidden className={styles.title} data-stable-name="NoItemsNotifierTitle">
          {title}
        </h3>
      )}
      { tagline && (
        <p aria-hidden className={styles.tagline} data-stable-name="NoItemsNotifierTagline">
          {tagline}
        </p>
      )}
      {contactInfo && (
      <p className={styles.tagline} data-stable-name="NoItemsNotifierContactInfo">
        {contactInfo}
      </p>
      )}
    </div>
  );
};
